const Nav = {
    init() {
        const navMenuTrigger = document.querySelector('.nav__menu-trigger');
        if (navMenuTrigger) {
            navMenuTrigger.addEventListener('click', () => {
                document.body.classList.add('menu-open');
            });
        }

        const navMenuClose = document.querySelector('.nav__menu-close');
        if (navMenuClose) {
            navMenuClose.addEventListener('click', () => {
                document.body.classList.remove('menu-open');
            });
        }

        const onLangOpen = () => {
            document.body.classList.remove('lang-open');
            window.removeEventListener('click', onLangOpen, true);
        };

        const navLangTrigger = document.querySelector('.nav__lang-trigger');
        if (navLangTrigger) {
            navLangTrigger.addEventListener('click', () => {
                document.body.classList.add('lang-open');
                window.addEventListener('click', onLangOpen, true);
            });
        }
    },
};

export default Nav;
